import React from "react";
import NoteAttachmentPanel from "../../molecules/NoteAttachmentPanel";
import QuillComponent from "../../commonComponent/QuillComponent";
import {
  NOTE_ATTACHMENT_ACCEPT,
} from "../../../constants/noteAttachment.constants";

const NoteEditorWorkspace = ({
  autoSave,
  content,
  fileTransferPromo,
  isAttachmentHighlighted,
  onAttachmentDownload,
  onAttachmentRemovalUndo,
  onAttachmentRemove,
  onAttachmentSelect,
  onAttachmentSelectionClear,
  onContentChange,
  onToggleAutoSave,
  pendingRemovalBlobNames,
  saveMode,
  savedAttachments,
  selectedAttachments,
}) => (
  <div className="md:w-[70%]">
    <QuillComponent
      autoSaveCheckIntervalMs={autoSave.checkIntervalMs}
      fileTransferPromo={fileTransferPromo}
      isAutoSaveEnabled={autoSave.isEnabled}
      isAutoSaveSaving={autoSave.isSaving}
      onChange={onContentChange}
      onToggleAutoSave={onToggleAutoSave}
      value={content}
    />
    <NoteAttachmentPanel
      acceptedFileTypes={NOTE_ATTACHMENT_ACCEPT}
      isDisabled={saveMode === "offline"}
      isHighlighted={isAttachmentHighlighted}
      onClearSelectedFile={onAttachmentSelectionClear}
      onDownloadAttachment={onAttachmentDownload}
      onRemoveSavedAttachment={onAttachmentRemove}
      onSelectFiles={onAttachmentSelect}
      onUndoRemoveSavedAttachment={onAttachmentRemovalUndo}
      pendingRemovalBlobNames={pendingRemovalBlobNames}
      savedAttachments={savedAttachments}
      selectedFiles={selectedAttachments}
    />
  </div>
);

export default NoteEditorWorkspace;
